import { render, staticRenderFns } from "./InformationInquiry.vue?vue&type=template&id=2aeed07c&scoped=true"
import script from "./InformationInquiry.vue?vue&type=script&lang=js"
export * from "./InformationInquiry.vue?vue&type=script&lang=js"
import style0 from "./InformationInquiry.vue?vue&type=style&index=0&id=2aeed07c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeed07c",
  null
  
)

export default component.exports